module.exports = __webpack_public_path__ + "img/student-service-center.f17d042.jpg";